export default {
  alert_id: 'alert-79b80521-a7e7-40a6-999f-2baea7e76541',
  associated_role_type: 'RESPONSIBLE',
  authorized_entity: {
    id: 'Lucas_CSP',
    name: 'Lucas Test CS',
    phone: '18888888888',
  },
  covering_psap: {
    id: 'lucas_delta',
    name: 'FE_DELTA',
    phone: '15555555550',
  },
  covering_psap_first_viewed_time: null,
  created_time: 1705506504702,
  description: 'Implemented needs-based methodology',
  dispatch_requested_time: 1705506531448,
  emergency_type: {
    display_name: 'Fire',
    name: 'FIRE',
  },
  followers: [],
  incident_time: 1705506504494,
  is_chat_enabled: false,
  is_media_enabled: false,
  last_updated_time: 1705506542886,
  location: {
    civic: {
      city: 'Nashville',
      country: 'US',
      name: null,
      state: 'TN',
      street_1: '1201 Doctor DB Todd Junior Boulevard',
      street_2: null,
      zip_code: '37208',
    },
    geodetic: {
      latitude: 36.17036520895414,
      longitude: -86.80736261289903,
      uncertainty_radius: 10,
    },
    provided_location: 'GEODETIC',
  },
  location_history: [
    {
      civic: {
        city: 'Nashville',
        country: 'US',
        name: null,
        state: 'TN',
        street_1: '1201 Doctor DB Todd Junior Boulevard',
        street_2: null,
        zip_code: '37208',
      },
      created_at: 1705506504691,
      geodetic: {
        latitude: 36.17036520895414,
        longitude: -86.80736261289903,
        uncertainty_radius: 10,
      },
      provided_location: 'GEODETIC',
    },
  ],
  log_messages: [],
  notified_agencies: [],
  service_provider_name: 'Strosin Group',
  site_type: {
    display_name: 'Vehicle',
    name: 'VEHICLE',
  },
  sla_expiration_time: 1705506561448,
  source_id: 'f4846792-dca0-4028-92e6-5240ad119654',
  status: {
    display_name: 'Accepted',
    entity_display_name: 'FE_DELTA',
    name: 'ACCEPTED',
    sender: 'Jack Hsu',
  },
  supplemental_only: false,
  isIgnoredByUserID: '',
  isStatusUpdated: false,
  isUnread: false,
  numStatusUpdates: 0,
  numUnreads: 0,
};
